export default "__VITE_PUBLIC_ASSET__123a6d0d__"